module.exports = __webpack_public_path__ + "img/telegram.9157d101.svg";